import React from 'react';
import SectionHead from './SectionHead';

function Technology({ data }) {
  return (
    <section className="section alt" id="technology">
      <SectionHead title={data.title} copy={data.copy} />
      <div className="tech-grid">
        {data.items.map((item) => (
          <div className="tech-card" key={item.title}>
            <h3>{item.title}</h3>
            <p>{item.copy}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Technology;
